import React from "react";
import { connect } from "react-redux";

import Breadcrumb from "./Breadcrumb";
import getPageTitle from "../../../_selectors/appSelectors/getPageTitle";
import getBreadcrumbs from "../../../_selectors/appSelectors/getBreadcrumbs";
const PageTitle = ({ header, crumbs }) => {
  if (!header.show) {
    return null;
  }

  return (
    <div className="page-title">
      <h1>{header.title}</h1>
      <p>{header.description}</p>
      <Breadcrumb items={crumbs} />
    </div>
  );
};
const mapStateToProps = (state, ownProps) => ({
  header: getPageTitle(state),
  crumbs: getBreadcrumbs(state)
});

export default connect(mapStateToProps)(PageTitle);



// WEBPACK FOOTER //
// ./src/_components/Layout/PageTitle/index.js